export default __webpack_public_path__ + "static/images/no_image.7a2dca8a.png";